import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EClientType, ShareUserInfo } from '../models/share-user-info.model';
import { VehicleClass, VehicleModel, VehiclesPrice } from '../models/vehicles.model';
import { LocalStorageService } from './local-storage.service';

@Injectable({
	providedIn: 'root',
})
export class VehiclesService {
	clientType: number = 0;
	clientLocation: any = [];

	constructor(
		private readonly http: HttpClient,
		private localStorage: LocalStorageService
	) {
		this.clientType = Number(localStorage.getItem('ROD-simulation.clientType'));
		this.clientLocation = localStorage.getItem('ROD-simulation.location');
	}

	getVehiclesPrice() {
		return this.http.get<VehiclesPrice>(`${environment.apiUrl}vehicles/prices`);
	}

	public sendUserInformation(isDealer: boolean, isSeller: boolean, isVE: boolean, clientType: EClientType): number | null {
		const shareUserInfo = new ShareUserInfo(isDealer, isSeller, isVE, clientType);
		return shareUserInfo.sendUserInformation();
	}

	getVehicleClass() {
		this.clientLocation = this.localStorage.getItem('ROD-simulation.location');
		this.clientType = Number(this.localStorage.getItem('ROD-userType')) || Number(this.localStorage.getItem('ROD-simulation.clientType'));

		this.clientLocation = JSON.parse(this.clientLocation);
		return this.http.get<any>(`${environment.apiUrl}vehicles/vehicleClass/client-type/${this.clientType}/latitude/${this.clientLocation[0]}/longitude/${this.clientLocation[1]}`);
	}

	getVehicleByModel(slug: string) {
		return new Promise<VehicleModel | undefined>(resolve => {
			this.getVehicleClass().subscribe(res => {
				const vehiclesClass: VehicleClass[] = res.data;
				const vehicles = this.getVehicles(vehiclesClass);
				const vehicle = this.getFilterVehicleBySlug(vehicles, slug);

				resolve(vehicle);
			});
		});
	}

	private getVehicles(vehiclesClass: VehicleClass[]): VehicleModel[] {
		const vehiclesArray: VehicleModel[] = [];
		vehiclesClass.forEach(vehicles => {
			if (vehicles.vehicleModels) {
				vehicles.vehicleModels.forEach(vehicleModel => {
					vehiclesArray.push(vehicleModel);
				});
			}
		});
		return vehiclesArray;
	}

	private getFilterVehicleBySlug(vehicles: VehicleModel[], slug: string) {
		return vehicles.find(vehicle => {
			return vehicle.modelSlug === slug;
		});
	}
}
